const siteUrl = 'https://brettspielgeister.de';
const siteName = 'Brettspielgeister';
const previewImage = '/preview.png';
// The final production URL. This becomes fetchable as soon as the custom
// domain is connected to the Cloudflare Pages project.
const previewImageUrl = `${siteUrl}${previewImage}`;
const pages = {
  '/': {
    title: 'Brettspielgeister – Gesellschaftsspiele & Pädagogik in Heusenstamm',
    description: 'Gesellschaftsspiele als Bildungsmedium: Die Brettspielgeister aus Heusenstamm bieten Angebote für Schulen, Kitas, Bibliotheken und Spiele-Events.'
  },
  '/impressum': {
    title: 'Impressum | Brettspielgeister',
    description: 'Impressum und Kontaktdaten der Brettspielgeister GbR von Julia und Marco Dornburg in Heusenstamm.'
  },
  '/datenschutz': {
    title: 'Datenschutz | Brettspielgeister',
    description: 'Datenschutzhinweise zur Website der Brettspielgeister GbR aus Heusenstamm.'
  },
  '/agb': {
    title: 'Allgemeine Geschäftsbedingungen | Brettspielgeister',
    description: 'Allgemeine Geschäftsbedingungen der Brettspielgeister GbR für Seminare, Kurse und weitere Leistungen.'
  }
};
const structuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization', '@id': `${siteUrl}/#organization`,
      name: siteName, legalName: 'Brettspielgeister GbR', url: `${siteUrl}/`,
      logo: `${siteUrl}/logo.svg`, email: 'Brettspielgeister@web.de', telephone: '+491633541498',
      address: { '@type': 'PostalAddress', streetAddress: 'Im Buchwald 85', postalCode: '63150', addressLocality: 'Heusenstamm', addressCountry: 'DE' }
    },
    {
      '@type': 'WebSite', '@id': `${siteUrl}/#website`, name: siteName,
      url: `${siteUrl}/`, inLanguage: 'de-DE', publisher: { '@id': `${siteUrl}/#organization` }
    }
  ]
};
function getSeo(path) {
  const normalized = path.replace(/\/+$/, '') || '/';
  const page = pages[normalized];
  return {
    ...(page || { title: 'Seite nicht gefunden | Brettspielgeister', description: 'Diese Seite wurde nicht gefunden. Entdecken Sie die Angebote der Brettspielgeister.' }),
    url: `${siteUrl}${normalized}`,
    robots: page ? 'index, follow, max-image-preview:large' : 'noindex, follow'
  };
}
function applySeo(path) {
  const seo = getSeo(path);
  document.title = seo.title;
  const setMeta = (attribute, key, value) => {
    let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute(attribute, key);
      document.head.appendChild(tag);
    }
    tag.content = value;
  };
  setMeta('name', 'description', seo.description);
  setMeta('name', 'robots', seo.robots);
  for (const [key, value] of Object.entries({ 'og:type': 'website', 'og:locale': 'de_DE', 'og:site_name': siteName, 'og:title': seo.title, 'og:description': seo.description, 'og:url': seo.url })) setMeta('property', key, value);
  setMeta('name', 'twitter:card', previewImage ? 'summary_large_image' : 'summary');
  setMeta('name', 'twitter:title', seo.title);
  setMeta('name', 'twitter:description', seo.description);
  if (previewImage) {
    setMeta('property', 'og:image', previewImageUrl);
    setMeta('name', 'twitter:image', previewImageUrl);
    setMeta('property', 'og:image:alt', 'Die Brettspielgeister – Fachkräfte für Gesellschaftsspiele');
    setMeta('name', 'twitter:image:alt', 'Die Brettspielgeister – Fachkräfte für Gesellschaftsspiele');
  }
  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = seo.url;
}
export { siteUrl, siteName, previewImage, previewImageUrl, pages, structuredData, getSeo, applySeo };
